import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  doLogin,
  IS_LOGGED_IN_KEY,
  LINKS_SURVEY_ENTRY,
  PASSWORD_KEY,
  passwordChanged,
  ROLES,
  USER_ID,
  USERNAME_KEY,
  usernameChanged
} from "../../ducks/login";

import Login from "./Login";

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.login[IS_LOGGED_IN_KEY],
    username: state.login[USERNAME_KEY],
    password: state.login[PASSWORD_KEY],
    surveyEntryHref: state.login[LINKS_SURVEY_ENTRY],
    userId: state.login[USER_ID],
    role: state.login[ROLES]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      doLogin,
      usernameChanged,
      passwordChanged
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
